module.exports = __webpack_public_path__ + "img/miica.561833e8.png";